import { Animate } from '@syconium/little-miss-figgy'

import { Badge } from './Badge/index'
import { BadgeWrapper, Container } from './styles'

import type { ProductCatalogTextBadge } from '../../../../../../../__generated__/graphql/catalog/graphql'

type BadgesSectionProps = {
  badges: ReadonlyArray<string> | Array<string> | Array<ProductCatalogTextBadge>
  leftOffset?: boolean
  topOffset?: boolean
  className?: string
}

export const BadgesSection = ({ badges, leftOffset, topOffset, className }: BadgesSectionProps) => {
  return (
    <Container {...{ leftOffset, topOffset }} className={className}>
      {badges.map(badge => {
        const id = typeof badge === 'string' ? badge.toLowerCase() : badge.id.toLowerCase()
        const displayValue = typeof badge === 'string' ? badge : badge.displayValue
        const isFinalSale = id === 'final sale'
        return (
          <Animate.FadeIn key={id}>
            <BadgeWrapper isFinalSale={isFinalSale}>
              <Badge text={displayValue} isFinalSale={isFinalSale} />
            </BadgeWrapper>
          </Animate.FadeIn>
        )
      })}
    </Container>
  )
}
